angular.module('gym.components').directive('financialsWidget', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/dashboard/financials_widget.html.slim'),
    scope: {
      privacyModeEnabled: '=',
      gym: '=',
      netRevenueVisible: '=',
      monthlyRevenueVisible: '='
    },
    controller: ["$scope", "Dashboard", "EmploymentService", function($scope, Dashboard, EmploymentService) {
      var load;
      $scope.isLoading = true;
      $scope.currency = $scope.gym.currency_symbol;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.$on('dashboard:refresh', function() {
        return load();
      });
      load = function() {
        return Dashboard.customGET('financials').then(function(data) {
          $scope.revenue = data.plain();
          // Store graph data for React component
          $scope.netRevenueGraphData = data.net_revenue_graph_data;
          return $scope.mrrGraphData = data.mrr_graph_data;
        });
      };
      return load();
    }]
  };
});
